/**
 * 建发代理的品牌的相关车辆信息
 */
import React from 'react';

import { Input, Row, Col, Select, Tooltip, DatePicker, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';

import Loading from '../../ui/Loading';

class JFBrandIndex extends React.Component {
    columns = [{
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '新车牌号',
        dataIndex: 'plateNo',
        width: '10%',
    }, {
        title: '厂牌型号',
        dataIndex: 'brandModel',
        width: '10%',
    }, {
        title: '新车主',
        dataIndex: 'buyerName',
        width: '10%',
    }, {
        title: '车主电话',
        dataIndex: 'buyerTel',
        width: '10%',
    }, {
        title: '开票时间',
        dataIndex: 'billingTime',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {}, //查询数据

        loadingVisible: false,
    };

    //导出
    download = () => {
        let queryData = this.state.queryData;
        this.setState({ loadingVisible: true });
        let fileName = "交易数据.xlsx";
        queryData.pageSize = 5000;
        http.download({
            url: '/tradeBrand/downloadTradeBrand',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                messager.alert(res, "异常", "error");
                this.setState({ loadingVisible: false });
            }
        });
    }



    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    selectChange = (value) => {
        let queryData = this.state.queryData;
        queryData.brand = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ marginRight: '10px' }} />
                                <Input.Search
                                    placeholder="厂牌型号"
                                    onSearch={this.inputSearch.bind(this, "brandModel")}
                                    enterButton
                                    style={{ width: '200px', marginRight: '10px' }}
                                />
                                <Select defaultValue="" style={{ width: 150, marginRight: '10px' }} onChange={this.selectChange}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="Porsche">保时捷</Select.Option>
                                    <Select.Option value="JLR">捷豹路虎</Select.Option>
                                    <Select.Option value="Audi">奥迪</Select.Option>
                                    <Select.Option value="Lincoln">林肯</Select.Option>
                                    <Select.Option value="Volvo">沃尔沃</Select.Option>
                                    <Select.Option value="Cadillac">凯迪拉克</Select.Option>
                                    <Select.Option value="Acura">讴歌</Select.Option>
                                    <Select.Option value="Volkswagen">进口大众</Select.Option>
                                    <Select.Option value="Mitsubishi">三菱</Select.Option>
                                </Select>
                                <Tooltip title="导出相关品牌的信息！">
                                    <Button type="primary" style={{ float: "right", marginRight: '10px' }} onClick={this.download}>导出</Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    )}
                    rowKey="applicationId"
                    url="/tradeBrand/pageTradeBrand"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在处理中，请稍候..." />
            </div>
        )
    }

}

export default JFBrandIndex;